import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react'
import './PcDetails.scss'

import { useHistory, useLocation, useParams } from 'react-router-dom'
import BundleRender from 'src/components/BundleRender/BundleRender'
import axios from 'axios'
import { urlSearch } from 'src/utils/tools'
import Icon from '@ant-design/icons'
import { icon_big_hover, icon_detail_hover, icon_homepage_hover, icon_small } from 'src/assets/svg'
import { Drawer } from 'antd'

// copy('Text');
interface DetailsProps {}
// 判断是否为全屏
export function isFullScreen() {
    return !!(
        document.fullscreen ||
        document.mozFullScreen ||
        document.webkitIsFullScreen ||
        document.webkitFullScreen ||
        document.msFullScreen
    )
}
function full(ele) {
    if (ele.requestFullscreen) {
        ele.requestFullscreen()
    } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen()
    } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen()
    } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen()
    } else if (ele.webkitEnterFullscreen) {
        // For Safari on iPadOS
        ele.webkitEnterFullscreen()
    } else if (ele.webkitRequestFullScreen) {
        // For earlier versions of Safari
        ele.webkitRequestFullScreen()
    }
}

const PcDetails: FunctionComponent<DetailsProps> = props => {
    const history = useHistory()

    const isSingle = sessionStorage.getItem('single')
    const locationParams = urlSearch(useLocation().search)
    const bundleDom = useRef(null)

    const [visible, setVisible] = useState(true)
    const [bundleInfo, setBundleInfo] = useState(
        {} as {
            name: string
            intro: string
            model: string
            cover: string
            bundleMax: number
            bundleMin: number
            light: { hsPath: string }
            background: { hsPath: string }
            camera: { hsPath: string }
        },
    )

    const [progressWidth, setProgressWidth] = useState(20)
    let progressId
    useEffect(() => {
        progressId = setInterval(() => {
            setProgressWidth(val => {
                if (val < 80) {
                    return val + 10
                } else {
                    clearInterval(progressId)
                    return val
                }
            })
        }, 500)
        bundleDom.current.addEventListener(
            'touchmove',
            function (e) {
                e.preventDefault()
            },
            { passive: false },
        ) //passive 参数不能省略，用来兼容ios和android
        return () => {
            clearInterval(progressId)
        }
    }, [])

    useEffect(() => {
        axios({
            method: 'get',
            url: '/api/display/view',
            params: {
                id: locationParams.id,
            },
        }).then(res => {
            setBundleInfo(res.data.data)
        })
    }, [])
    const controlClick = value => {
        if (value === 'home') {
            history.push({ pathname: '/' })
            return
        } else if (value === 'detail') {
            setOpen(true)
        }
    }
    const [open, setOpen] = useState(false)
    const [isFull, setIsFull] = useState(false)

    const onClose = () => {
        setOpen(false)
    }
    function exitFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        } else if (document.exitFullscreen) {
            document.exitFullscreen()
        }
    }
    const escClose = event => {
        if (!isFullScreen()) {
            exitFullscreen()
            setIsFull(false)
        }
    }
    useEffect(() => {
        document.addEventListener('fullscreenchange', escClose)
        document.addEventListener('mozfullscreenchange', escClose)
        document.addEventListener('webkitfullscreenchange', escClose)
        document.addEventListener('msfullscreenchange', escClose)

        return () => {
            document.removeEventListener('fullscreenchange', escClose)
            document.removeEventListener('mozfullscreenchange', escClose)
            document.removeEventListener('webkitfullscreenchange', escClose)
            document.removeEventListener('msfullscreenchange', escClose)
        }
    }, [])

    return (
        <>
            <div id="bd" className="cultural-details-pc" ref={bundleDom}>
                <p
                    style={{
                        display: !isFull ? 'block' : 'none',
                    }}
                    className="title-name"
                >
                    {bundleInfo.name}
                </p>
                {bundleInfo.name && (
                    <BundleRender
                        mode="pc"
                        isFull={isFull}
                        backgroundUrl={bundleInfo.background.hsPath}
                        bundleUrl={bundleInfo.model}
                        lightUrl={bundleInfo.light.hsPath}
                        cameraUrl={bundleInfo.camera.hsPath}
                        bundleMax={bundleInfo.bundleMax || 2}
                        bundleMin={bundleInfo.bundleMin || 0.3}
                        bundleDom={bundleDom}
                        onCallback={() => {
                            clearInterval(progressId)
                            setVisible(false)
                        }}
                    ></BundleRender>
                )}

                <div
                    style={{
                        display: isFull ? 'block' : 'none',
                    }}
                    className="exit_full"
                    onClick={() => {
                        function exitFullscreen() {
                            if (document.exitFullscreen) {
                                document.exitFullscreen()
                            } else if (document.exitFullscreen) {
                                document.exitFullscreen()
                            }
                        }
                        exitFullscreen()
                        setIsFull(false)
                    }}
                >
                    <Icon component={icon_small} />
                </div>

                <div
                    style={{
                        display: !isFull ? 'flex' : 'none',
                    }}
                    className="control"
                >
                    {!isSingle && (
                        <>
                            <div
                                onClick={() => {
                                    controlClick('home')
                                }}
                            >
                                <Icon component={icon_homepage_hover} />
                            </div>
                            <div className="xiaosi"></div>
                        </>
                    )}

                    <div
                        onClick={() => {
                            controlClick('detail')
                        }}
                    >
                        <Icon component={icon_detail_hover} />
                    </div>
                    <div className="xiaosi"></div>
                    <div
                        onClick={() => {
                            setIsFull(true)
                            const canvas = document.getElementById('bd')
                            full(canvas)
                        }}
                    >
                        <Icon component={icon_big_hover} />
                    </div>
                </div>
            </div>

            {visible && (
                <div className="progress-modal-pc">
                    <div className="progress-modal_inner">
                        <div className="progress">
                            <div
                                style={{
                                    width: `${progressWidth}%`,
                                }}
                            ></div>
                            <span className="loading">加载中…</span>
                        </div>
                        <img src={bundleInfo.cover} alt="" />
                    </div>
                </div>
            )}
            <Drawer closable={false} placement="right" onClose={onClose} open={open}>
                <div className="detail-pc">
                    <p className="title-name">{bundleInfo.name}</p>
                    <div className={`content-wrapper`}>
                        <div className={`content`}>
                            <p>{bundleInfo.intro || '暂无简介'}</p>
                        </div>
                    </div>
                </div>
            </Drawer>
        </>
    )
}

export default PcDetails
